var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCertificationServiceBody2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 238,
    viewBox: "0 0 238 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.74219,
    y: 12.5156,
    width: 142.031,
    height: 182.046,
    rx: 3.5,
    fill: "#F3F3F3",
    stroke: "#EDEDED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9742,
    y: 121.837,
    width: 109.825,
    height: 7.32167,
    rx: 3.66083,
    fill: "#CACACA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9742,
    y: 102.315,
    width: 109.825,
    height: 7.32167,
    rx: 3.66083,
    fill: "#CACACA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9742,
    y: 141.363,
    width: 109.825,
    height: 7.32167,
    rx: 3.66083,
    fill: "#CACACA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9742,
    y: 160.897,
    width: 78.0978,
    height: 7.32167,
    rx: 3.66083,
    fill: "#CACACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.9002 48.4882L76.7857 39.3594L55.3425 48.4882V59.0738C55.3425 65.1921 54.816 71.6017 62.1616 81.3132C66.0398 86.4405 73.5268 89.5356 76.7857 90.442C79.2504 90.1183 85.5601 87.8394 91.0811 81.3132C97.9002 73.2526 97.9276 63.7677 97.9002 59.0738V48.4882Z",
    fill: "#3A7EFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1042 66.3341L73.7801 72.9559L86.0778 57.8203",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.92 119.484L191.577 84.2064C196.092 77.7453 195.233 68.9585 189.551 63.4948C187.806 61.8171 185.044 61.8276 183.312 63.5187L140.049 105.76C128.817 116.727 120.578 130.386 116.115 145.437L103.892 186.669C98.1763 205.947 112.672 225.279 132.779 225.196L195.54 224.935C201.244 224.911 206.671 222.471 210.475 218.219C214.15 214.111 215.112 208.245 212.94 203.178L212 200.984C218.859 200.388 224.555 195.447 226.115 188.741L226.519 187.003C227.7 181.926 225.47 176.666 221 173.984L222.404 173.563C227.517 172.029 231.04 167.349 231.098 162.01L231.141 158.159C231.208 151.981 226.841 146.642 220.771 145.484C226.658 145.484 231.523 140.892 231.862 135.015L232.11 130.712C232.462 124.619 227.615 119.484 221.511 119.484H166.92Z",
    fill: "#FFDCD5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertificationServiceBody2);
export default __webpack_public_path__ + "static/media/IcCertificationServiceBody2.176eb38a8e8361795f7cb030935dd1b2.svg";
export { ForwardRef as ReactComponent };